import React from "react";
import NCube from "./NCube";

function About() {
  return (
    <section id="about" className="min-h-screen flex items-center px-8 md:px-16 lg:px-24 py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-12">
          {/* Left Content */}
          <div>
            <h2 className="text-6xl md:text-7xl lg:text-8xl font-bold text-primary mb-8">
              About
            </h2>
            <p className="text-xl md:text-2xl text-secondary mb-6">
              Part curious tinkerer, part systems thinker — I make the complicated feel intuitive.
            </p>
            <p className="text-xl md:text-lg text-secondary mb-6">
            Curiosity is my default. I gravitate toward complexity, sketch ideas in the margins, and ask "what if" long before thinking about solutions. It's how I stay sharp and make sense of messy problems.
            </p>
            {/* Skills */}
            <div className="grid grid-cols-2 gap-6">
              <div>
                <h3 className="text-lg font-semibold text-primary mb-3">Past</h3>
                <ul className="space-y-2 text-secondary">
                  <li>TheReplaceBook</li>
                  <li>Crickets</li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-primary mb-3">Present</h3>
                <ul className="space-y-2 text-secondary">
                  <li>GHWR</li>
                  <li>Mush Ado About Nothing</li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
            </div>
          </div>
          
          {/* Right Content - Tesseract (below text on mobile, beside on desktop) */}
          <div className="flex items-center justify-center lg:justify-end order-last">
            <div className="relative w-full h-[400px] md:h-[600px] lg:h-[900px] lg:w-[900px]">
              {/* NCube Component */}
              <div className="absolute inset-0 flex items-center justify-center">
                <NCube 
                  dimension={4}
                  size={700}
                  strokeColor="#222222"
                  strokeWidth={1}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;